import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { DS } from '../ds';
interface ProcessStep {
  id: number;
  number: string;
  title: string;
  description: string;
  tags: string[];
  details: string;
}
interface ProcessSectionProps {
  onCTA?: (id: string) => void;
}
const steps: ProcessStep[] = [{
  id: 1,
  number: '01',
  title: 'Envía el caso',
  description: 'Archivos STL, modelos 3D o diagnóstico digital en sedes aliadas.',
  tags: ['STL', 'Escaneo intraoral', 'Diagnóstico'],
  details: 'El profesional envía toda la información digital necesaria para iniciar el análisis del caso de ortodoncia.'
}, {
  id: 2,
  number: '02',
  title: 'Análisis de validez',
  description: 'Revisión clínica de la viabilidad del caso con tu equipo de especialistas.',
  tags: ['Validación', 'Clínica', 'Equipo'],
  details: 'Nuestro equipo de ortodoncistas valida si el caso es viable para alineadores invisibles.'
}, {
  id: 3,
  number: '03',
  title: 'Planeación digital',
  description: 'Diseño del plan de tratamiento con herramientas de modelado 3D de precisión.',
  tags: ['3D', 'Modelado', 'CAD'],
  details: 'Creamos un plan de tratamiento detallado con simulación 3D del movimiento dental.'
}, {
  id: 4,
  number: '04',
  title: 'Validación profesional',
  description: 'Confirmación del plan con el especialista tratante antes de fabricación.',
  tags: ['Aprobación', 'Profesional', 'Control'],
  details: 'El odontólogo revisa y aprueba el plan antes de proceder con la fabricación.'
}, {
  id: 5,
  number: '05',
  title: 'Fabricación precisa',
  description: 'Impresión 3D y termoformado de alineadores con precisión submilimétrica.',
  tags: ['Impresión 3D', 'Termoformado', 'Precisión'],
  details: 'Fabricamos los alineadores usando tecnología de punta con precisión de micras.'
}, {
  id: 6,
  number: '06',
  title: 'Entrega eco-premium',
  description: 'Kit completo en caja kraft con bolsa lino y estuche personalizado.',
  tags: ['Kit eco', 'Packaging', 'Personalización'],
  details: 'Entregamos los alineadores en un kit eco-premium con tu marca y material sostenible.'
}];
export const ProcessSection = ({
  onCTA
}: ProcessSectionProps) => {
  const [activeStep, setActiveStep] = useState<number>(1);
  return <section id="proceso" style={{
    padding: '80px 24px',
    background: '#fff'
  }} data-id="element-722" data-mp="22p7j7f4id6ck">
      <div style={{
      maxWidth: '860px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }} data-id="element-723" data-mp="27qerdfakc7jr">
        {/* Header */}
        <div style={{
        marginBottom: '48px',
        textAlign: 'center'
      }} data-id="element-724" data-mp="3n5ubqt7umky2">
          <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '6px 14px',
          background: DS.color.mint,
          borderRadius: DS.radius.pill,
          marginBottom: '16px'
        }} data-id="element-725" data-mp="3n6n9x5sqs24l">
            <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: DS.color.teal
          }} data-id="element-726" data-mp="1bgnsk3glyena" />
            <span style={{
            fontFamily: DS.font.body,
            fontSize: '11px',
            fontWeight: 700,
            color: DS.color.tealDeep,
            letterSpacing: '0.09em',
            textTransform: 'uppercase'
          }} data-id="element-727" data-mp="1z82xm3zrra28">
              Proceso clínico
            </span>
          </div>

          <h2 style={{
          fontFamily: DS.font.heading,
          fontSize: 'clamp(1.8rem, 4vw, 2.4rem)',
          fontWeight: 700,
          color: DS.color.ink,
          letterSpacing: '-0.025em',
          lineHeight: 1.14,
          margin: '0 auto 12px',
          maxWidth: '620px'
        }} data-id="element-728" data-mp="247z72ir8jtp6">
            Un flujo digital pensado para profesionales
          </h2>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '16px',
          color: DS.color.body,
          maxWidth: '600px',
          margin: '0 auto'
        }} data-id="element-729" data-mp="l8rie3wykcqg">
            El profesional mantiene el control en cada etapa.
          </p>
        </div>

        {/* Acordeón de pasos */}
        <div style={{
        maxWidth: '860px',
        background: '#fff',
        borderRadius: DS.radius.cardLg,
        border: `1px solid ${DS.color.border}`,
        overflow: 'hidden',
        boxShadow: DS.shadow.card
      }} data-id="element-730" data-mp="3tokzokz45s8k">
          {steps.map((step, index) => {
          const isOpen = activeStep === step.id;
          return <div key={step.id} data-id="element-731" data-mp="3avpd2avc7qh8" data-mpi={index}>
                <button type="button" aria-expanded={isOpen} onClick={() => setActiveStep(isOpen ? 0 : step.id)} style={{
              width: '100%',
              padding: '22px 24px',
              background: isOpen ? 'rgba(0, 170, 212, 0.08)' : '#fff',
              border: 'none',
              borderBottom: index < steps.length - 1 || isOpen ? `1px solid ${DS.color.border}` : 'none',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              textAlign: 'left',
              transition: `background-color 0.25s ${DS.ease.smooth}`
            }} onMouseEnter={e => {
              if (!isOpen) e.currentTarget.style.background = 'rgba(0, 170, 212, 0.04)';
            }} onMouseLeave={e => {
              if (!isOpen) e.currentTarget.style.background = '#fff';
            }} data-id="element-732" data-mp="1s2fh1xjo9ouh">
                  <div style={{
                display: 'flex',
                gap: '16px',
                alignItems: 'flex-start'
              }} data-id="element-733" data-mp="6r0fkh83nywv">
                    <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: isOpen ? DS.color.aqua : 'rgba(0, 170, 212, 0.15)',
                  color: isOpen ? '#fff' : DS.color.body,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: DS.font.body,
                  fontSize: '13px',
                  fontWeight: 700,
                  flexShrink: 0,
                  transition: `background-color 0.25s ${DS.ease.smooth}, color 0.25s ${DS.ease.smooth}`
                }} data-id="element-734" data-mp="zf61h7aw3tya">
                      {step.number}
                    </div>

                    <div data-id="element-735" data-mp="2jyryjsjjo84t">
                      <h3 style={{
                    fontFamily: DS.font.heading,
                    fontSize: '16px',
                    fontWeight: isOpen ? 700 : 600,
                    color: isOpen ? DS.color.tealDeep : DS.color.ink,
                    margin: '0 0 4px',
                    transition: `color 0.25s ${DS.ease.smooth}`
                  }} data-id="element-736" data-mp="2k0ck4snvsgqj">
                        {step.title}
                      </h3>
                      <p style={{
                    fontFamily: DS.font.body,
                    fontSize: '14px',
                    color: DS.color.body,
                    margin: 0,
                    lineHeight: 1.5
                  }} data-id="element-737" data-mp="1xq4dgkjzpfx7">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  <div aria-hidden="true" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '24px',
                height: '24px',
                flexShrink: 0,
                color: isOpen ? DS.color.aqua : DS.color.muted,
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: `transform 0.25s ${DS.ease.smooth}, color 0.25s ${DS.ease.smooth}`
              }} data-id="element-738" data-mp="2hdadykgdzffq">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" data-id="element-739" data-mp="thvvtcawgffy">
                      <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-740" data-mp="oo1fmiui6ilm" />
                    </svg>
                  </div>
                </button>

                {isOpen && <div style={{
              padding: '24px',
              background: 'rgba(0, 170, 212, 0.04)',
              borderBottom: index < steps.length - 1 ? `1px solid ${DS.color.border}` : 'none',
              animation: `processFade 0.28s ${DS.ease.out} both`
            }} data-id="element-741" data-mp="17gdeuwpv13rj">
                    <p style={{
                fontFamily: DS.font.body,
                fontSize: '14px',
                color: DS.color.body,
                margin: '0 0 16px',
                lineHeight: 1.6
              }} data-id="element-742" data-mp="35kluw1t9nst0">
                      {step.details}
                    </p>

                    <div style={{
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap'
              }} data-id="element-743" data-mp="3ai5bh8dfsho4">
                      {step.tags.map(tag => <span key={tag} style={{
                  padding: '6px 12px',
                  background: DS.color.mint,
                  borderRadius: '8px',
                  fontFamily: DS.font.body,
                  fontSize: '12px',
                  fontWeight: 600,
                  color: DS.color.tealDeep
                }} data-id="element-744" data-mp="23dfrppxb71z">
                          {tag}
                        </span>)}
                    </div>

                    <div role="progressbar" aria-valuenow={step.id} aria-valuemin={1} aria-valuemax={steps.length} aria-label={`Etapa ${step.id} de ${steps.length}`} style={{
                marginTop: '18px',
                height: '4px',
                background: 'rgba(0, 170, 212, 0.12)',
                borderRadius: '8px',
                overflow: 'hidden'
              }} data-id="element-745" data-mp="4mqj7e66948u">
                      <div style={{
                  height: '100%',
                  width: `${step.id / steps.length * 100}%`,
                  background: DS.color.aqua,
                  transition: `width 0.3s ${DS.ease.out}`
                }} data-id="element-746" data-mp="1g1nakuptw5jd" />
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        {/* CTA — precios */}
        <div style={{
        marginTop: '40px',
        padding: '22px 28px',
        borderRadius: DS.radius.cardLg,
        background: 'rgba(0, 170, 212, 0.08)',
        border: `1px solid ${DS.color.aqua}30`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap'
      }} data-id="element-747" data-mp="15nz82j0m3dbi">
          <div data-id="element-748" data-mp="2l2ejyu86gnoc">
            <div style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: '17px',
            color: DS.color.ink,
            marginBottom: '4px'
          }} data-id="element-749" data-mp="2l2wmu9pci058">
              ¿Cuánto cuesta fabricar tus casos con Alinova?
            </div>
            <div style={{
            fontFamily: DS.font.body,
            fontSize: '14px',
            color: DS.color.body
          }} data-id="element-750" data-mp="7swt4nv3vm9u">
              Precios claros en pesos colombianos, sin costos ocultos.
            </div>
          </div>

          <a href="#planes" onClick={e => {
          e.preventDefault();
          onCTA?.('planes');
        }} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '13px 26px',
          borderRadius: DS.radius.pill,
          background: '#00AAD4',
          boxShadow: '0 8px 26px rgba(0, 170, 212, 0.42)',
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          transition: `background-color 0.22s ${DS.ease.smooth}, box-shadow 0.22s ${DS.ease.smooth}, transform 0.22s ${DS.ease.smooth}`
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#0099CC';
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 12px 34px rgba(0, 170, 212, 0.55)';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#00AAD4';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 8px 26px rgba(0, 170, 212, 0.42)';
        }} data-id="element-751" data-mp="lrmtqdh4w42y">
            Conoce nuestros precios
            <ArrowRightIcon size={15} aria-hidden="true" data-id="element-752" data-mp="1y7nrtviq4673" />
          </a>
        </div>
      </div>

      <style data-id="element-753" data-mp="1ta4d6ui45rem">{`
        @keyframes processFade {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>;
};